module.exports = __webpack_public_path__ + "img/agvania_no.73acd2ed.png";